<p>
  {{translate.instant('admin.home')}}
</p>
